<template>
  <div style="width: 100%;">
    <div class="main-banner">
      <!-- Swiper -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide bg1">
            <h2 class="banner-title-main">
              <span>北京天行数科数据科技有限公司</span><br>
              <p>专注数据价值&nbsp;&nbsp;&nbsp;&nbsp;专助共同发展</p>
            </h2>
          </div>
          <div class="swiper-slide bg2">
            <h2 class="banner-title-main2">
              <span>提供多元化多业务场景</span><br>
              <span>所需要的定制化数据产品</span>
            </h2>
          </div>
          <div class="swiper-slide bg3">
            <h2 class="banner-title-main2">
              <span>精准定位风控痛点</span><br>
              <span>全面提升反欺诈能力</span>
            </h2>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  </div>
</template>

<script>

  import Swiper from 'swiper/dist/js/swiper.min'

  export default {
    name: 'Main',
    data () {
      return {
      }
    },
    mounted: function () {
      var swiper = new Swiper('.swiper-container', {
        spaceBetween: 30,
        loop:true,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    },
    methods: {
    }
  }
</script>

<style scoped>

  .swiper-container {
    width: 100%;
    height: 100%;

  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background-repeat:no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/Main.vue